const NotifierModule = {
  namespaced: true,
  state: {
    content: '',
    color: '',
    options: {},
  },
  actions: {
    showMessage ({ commit }, payload) {
      commit('SHOW_MESSAGE', payload)
    }
  },
  mutations: {
    SHOW_MESSAGE (state, payload) {
      state.content = payload.content
      state.color = payload.color
      state.options = payload.options
    }
  },
  getters: {}
}

export default NotifierModule
